// Google Consent Mode v2 helpers
const STORAGE_KEY = "dataminerarg_consent_v1";

export const DEFAULT_PREFERENCES = {
  analytics_storage: false,
  ad_storage: false,
  ad_user_data: false,
  ad_personalization: false,
};

function safeGtag(...args) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  } else {
    window.dataLayer.push(args);
  }
}

export function readStoredConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      preferences: { ...DEFAULT_PREFERENCES, ...(parsed.preferences || {}) },
      updatedAt: parsed.updatedAt || null,
    };
  } catch (e) {
    return null;
  }
}

export function storeConsent(preferences) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        preferences,
        updatedAt: new Date().toISOString(),
      }),
    );
  } catch (e) {
    /* ignore quota errors */
  }
}

function toGoogleValue(bool) {
  return bool ? "granted" : "denied";
}

export function applyConsent(preferences) {
  const payload = {
    analytics_storage: toGoogleValue(preferences.analytics_storage),
    ad_storage: toGoogleValue(preferences.ad_storage),
    ad_user_data: toGoogleValue(preferences.ad_user_data),
    ad_personalization: toGoogleValue(preferences.ad_personalization),
  };
  safeGtag("consent", "update", payload);
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "cookie_consent_update", ...payload });
  }
}

export function updateConsent(preferences) {
  const normalized = { ...DEFAULT_PREFERENCES, ...preferences };
  storeConsent(normalized);
  applyConsent(normalized);
  return normalized;
}

export function acceptAll() {
  return updateConsent({
    analytics_storage: true,
    ad_storage: true,
    ad_user_data: true,
    ad_personalization: true,
  });
}

export function rejectAll() {
  return updateConsent({ ...DEFAULT_PREFERENCES });
}

export function reapplyStoredConsent() {
  const stored = readStoredConsent();
  if (stored && stored.preferences) {
    applyConsent(stored.preferences);
    return stored.preferences;
  }
  return null;
}

export const CONSENT_STORAGE_KEY = STORAGE_KEY;
